/* eslint-disable import/no-cycle */
import { IBaseEmployee } from './Employee';

export enum LedgerEntryType {
  CREDIT = 'credit',
  DEBIT = 'debit',
  PENDING_CREDIT = 'pending_credit',
  PENDING_CREDIT_REVERTED = 'pending_credit_reverted',
  SITE_CREATED = 'site_created',
}

export enum TransactionReferenceType {
  ACCEPTANCE_PAYMENT = 'acceptance_payment',
  ACH = 'ach',
  BALANCE_ADJUSTMENT = 'balance_adjustment',
  PAYOUT = 'payout',
  SITE = 'site',
}

export interface ILedgerEntry {
  id: string;
  amount: number;
  balance: number;
  employee?: IBaseEmployee;
  entryType: LedgerEntryType;
  description: string;
  pendingFunds: number;
  seqNum: number;
  txnRefId: string;
  txnRefNotes?: string;
  txnRefType: TransactionReferenceType;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
}

export interface IFeeLedgerEntry extends Omit<ILedgerEntry, 'employee'> {
  employeeId: string;
  employeeName: string;
  entryReason: string;
}

export interface IAcceptanceLedgerEntry extends Omit<IFeeLedgerEntry, 'pendingFunds'> {}
